import {Route} from "../../../registry/routes.js"
import createFolder from "../../../components/actions/CreateFolder.vue";

const r = new Route("create-folder", "folder/create", {"create-folder":createFolder}, {componentType:"bin_modal_component",title:"Create Folder"}, [], true, null)

export default r